import { useQuery, UseQueryOptions } from 'react-query';

import {
  getContacts,
  GetContactsParams,
  GetContactsResponse,
} from '@app/store/transport-layer/document/address-book/contacts';

const useContacts = (
  params: GetContactsParams,
  options?: UseQueryOptions<GetContactsResponse, Error, GetContactsResponse>
) => {
  return useQuery<GetContactsResponse, Error, GetContactsResponse>({
    queryKey: ['address-book-contacts', params],
    queryFn: () => getContacts(params),
    ...options,
  });
};

export default useContacts;
